import { createContext } from 'react'

/**
 * Context for providing billing selectors to RightRailPaywall.
 * This allows each feature to provide its own selectors without
 * the component depending on a specific feature.
 */
export const RightRailPaywallContext = createContext(null)
